/**
 * reservedInstanceTag模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例


const reservedInstanceTag = {
  // 添加预留实例标签
  addTagList(params) {
    return $http.post(`${global.GT1_URL}/gt1/reservedInstanceTag/addTagList`, params);
  },
  // 查询分账标签
  listSubAccountTag(params) {
    return $http.post(`${global.GT1_URL}/gt1/subAccountTag/listSubAccountTag`, params);
  },
  // 查询标签
  queryTagList(params) {
    return $http.post(`${global.GT1_URL}/gt1/reservedInstanceTag/queryTagList`, params);
  }
}

export default reservedInstanceTag;



// WEBPACK FOOTER //
// ./src/api/reservedInstanceTag.js